<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogClient"
    width="80%"
    top="5vh"
    :before-close="doClose"
    :modal-append-to-body="false"
  >
    <el-form ref="serviceform" :model="serviceform" label-width="150px">
      <el-row :gutter="24">
        <el-col :sm="12" :xs="24">
          <el-form-item :label="$t('desc.dsn')">
            <el-input
              :value="serviceform.dsn"
              :disabled="true"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :xs="24">
          <el-form-item :label="$t('desc.ServiceOrderCode')">
            <el-input
              v-model="serviceform.serviceOrderCode"
              :disabled="true"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="$t('desc.pmc')">
            <template>
              <div class="tableDiv">
              <el-table
                :data="tableService"
                ref="tableService"
                stripe
                class="formSTable"
                :height="TableH"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  prop="workRang"
                  :label="$t('desc.workExtent')"
                  min-width="200px"
                >
                  <template slot-scope="scope">
                    <template>
                      <span>{{ scope.row.workRang }}</span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('desc.serviceDetails')"
                  min-width="150px"
                >
                  <template slot-scope="scope">
                    <template>
                      <el-checkbox
                        v-for="opt in scope.row.h2000"
                        :key="getOptionKey(scope.row.workRang, opt.code)"
                        :label="getOptionKey(scope.row.workRang, opt.code)"
                        v-model="serviceform.checkList"
                        disabled
                      >
                        {{ opt.label }}
                      </el-checkbox>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              </div>
            </template>
          </el-form-item>
        </el-col>

        <el-col :xs="24">
          <el-form-item>
            <el-button @click="doClose">{{ $t("button.cancel") }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "index",
  props: {
    dialogClient: false,
    title: "",
    TableH: "",
    serviceform: {},
    tableService: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    doClose() {
      this.$emit("dialogVisibleEvent", false);
    },
    setClassName({ row, rowIndex }) {
      return row.expand ? "" : "expand";
    },
    getOptionKey(a, b) {
      return a + "-" + b;
    },
  },
};
</script>

<style scoped>
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
  background-color: #409EFF;
  border-color: #409EFF;
}
 .el-checkbox__input.is-disabled+span.el-checkbox__label{
  color: #409EFF;
}
</style>